import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'

export const EventsContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  padding: `0 ${spacing.md}`,
  marginBottom: spacing.sm,
})
